<div class="sell-with-tally">
  <div class="title-info">
    <h4 translate>LEARN_MORE_PAGE.READY_TO</h4>
    <!-- <p translate>LEARN_MORE_PAGE.NOTIFICATION</p> -->
    <button class="btn btn-sky-blue" routerLink="/partner/sign-up" translate>
      LEARN_MORE_PAGE.START
    </button>
  </div>

  <div class="payment-bg">
    <img
      [src]="
        textDirection !== 'rtl'
          ? 'assets/images/product-img-en.png'
          : 'assets/images/product-img-ar.png'
      "
      alt="Taly-payment-img"
    />
  </div>
</div>
